import logo from './logo.svg';
import './App.css';
import { connect, useSelector } from 'react-redux';
import { BrowserRouter, BrowserRouter as Router } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { themeSettings } from "./theme/theme";
import { useEffect, useMemo, useState } from 'react';

import { fetchAuthSession, fetchUserAttributes, getCurrentUser } from 'aws-amplify/auth';
import RoleBasedRoutes from './routes/RoleBasedRoutes';
import { signUpUserInPoolAmplify } from './services/ampifyAdminService';
import { ADMIN_ACTIONS } from './services/cognitoAdminService';
import { ROLES } from './services/cognitoClientProviderHelper';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App({ signout, user }) {

  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  const [userDetails, setUserDetails] = useState(null);

  const getUserAuthSessionAndAttributes = async () => {
    try {
      fetchAuthSession().then(session => {
        //console.log("_blankErr","session: "+ JSON.stringify(session));
        //console.log("_blankErr","user: "+ JSON.stringify(user));
        //localStorage.setItem('aws_user', JSON.stringify(session));
        //localStorage.setItem('token', session?.credentials?.sessionToken);

        fetchUserAttributes().then(attributes => {
          const userData = { ...session, ...attributes, ...user }
          //console.log("✅ Final Combined User Info:", userData);
          //console.log("_blankErr","✅ Final Combined User Info:", userData);
          if (!userData['custom:role']) {
            userData['custom:role'] = 'Super Admin'; // default role
          }
          setUserDetails(userData);
          signUpUserInPoolAmplify(userData, ADMIN_ACTIONS.LIST_USERS, "parth.k@nexintain.com", "neXIntain@2027", ROLES.SUPER_ADMIN);
          return userData;
        });
      })
    } catch (err) {
      console.log("_blankErr","currentSession : ", err);
      console.log("currentSession : ", err);
    }
  }

  useEffect(() => {
    if (userDetails === null && user) {
      getUserAuthSessionAndAttributes();
    }
  }, [user, userDetails])

  return (
    <div className="App">
      {/* <header className="App-header"> */}
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {/* <AppRoutes signout={signout}/> */}
          {console.log("App userDetails: ", userDetails)}
          {userDetails && <RoleBasedRoutes role={userDetails["custom:role"]} userData={userDetails} signout={signout} />}
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            draggable
          />
        </ThemeProvider>
      </BrowserRouter>
      {/* </header> */}
    </div>
  );
}

export default App;